import { createRef } from 'react';

export const headerRef = createRef<HTMLElement>();
